import { Container, Row, Col, Button, ButtonGroup,Image } from "react-bootstrap";

import Thinking_AI from "../../../images/Welcome_ai.png";
import disscusion from "../../../images/discussion.png";
import '../StudyTwoInstruction.css'

export default function StudyOneInstructionPageTwo(){
    return (
        <Container className="study-item">
            <Row>
                <h1 style={{ fontWeight: 'bold'}}>Welcome Back !</h1>
                <Container style={{width:"90%"}}>
                    <br></br>
                    <Row className="align-items-start mb-4">
                        <Col xs={4} className="text-center">
                            <img 
                                src={Thinking_AI} 
                                alt="FEAI icon" 
                                style={{ width: "150px", height: "150px", }} 
                            />
                        </Col>
                        <Col xs={6}>
                        <div className="chat-bubble">
                            <p>
                            How do you feel about the results given by EmoAI?
                            </p>
                        </div>
                        </Col>
                    </Row> 
                    <Row>
                        <p>After you interacted with EmoAI, you may come up with some questions: </p>

                    </Row>
                    <Row className="align-items-start mb-4">
                        <Col xs={6}>
                            <div className="chat-bubble-left">
                            <ul>
                            <li>Why did AI make that result?</li>
                            <br />
                            <li>What's the difference between how humans and AI recognize emotions?</li>
                            <br />
                            <li>What factors impact EmoAI's results?</li>
                            </ul>
                            </div>
                        </Col>
                        <Col xs={4} className="text-end">
                            <img
                                src={disscusion}
                                alt="FEAI icon"
                                style={{ width: "200px", height: "200px", borderRadius: "50%" }}
                            />
                        </Col>
                    </Row>

                </Container>
            </Row>
        </Container>
    );
};